const Download = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 33.733 26.987"
  >
    <path
      id="Path_1687"
      data-name="Path 1687"
      d="M2,19.493c0-4.723,0-7.085.919-8.889A8.433,8.433,0,0,1,6.6,6.919C8.409,6,10.77,6,15.493,6H22.24c4.723,0,7.085,0,8.889.919A8.432,8.432,0,0,1,34.814,10.6c.919,1.8.919,4.165.919,8.889s0,7.085-.919,8.889a8.432,8.432,0,0,1-3.685,3.685c-1.8.919-4.166.919-8.889.919H15.493c-4.723,0-7.085,0-8.889-.919a8.433,8.433,0,0,1-3.686-3.685C2,26.578,2,24.217,2,19.493Zm17.761,5.954a1.265,1.265,0,0,1-1.789,0l-4.217-4.217a1.265,1.265,0,0,1,1.789-1.789L17.6,21.5V14.433a1.265,1.265,0,0,1,2.53,0V21.5l2.057-2.057a1.265,1.265,0,0,1,1.789,1.789Z"
      transform="translate(-2 -6)"
      fill="inherit"
      fill-rule="evenodd"
    />
  </svg>
);

export default Download;
